import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CreditReportsModel } from 'common/models/page-models/reports/credit-report/credit-report-data-model';
import { CreditReportsListingModel } from 'common/models/page-models/reports/credit-report/credit-report-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CreditReportsWidgetService } from 'common/widget/reports/credit-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class CreditReportsResolver extends GridResolver<CreditReportsModel, CreditReportsListingModel> {
    constructor(
        protected fs: CreditReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new CreditReportsModel();
        return dataModel;
    }
}